import {CategoryToAddModel} from "./category-to-add.model";

export class AddOrEditMenuRequestModel {
  public id: string;
  public name: string;
  public description: string;
  public languageId: number;
  public defaultCurrencyId?: string;
  public companyId: string;
  public categories: Array<CategoryToAddModel>;
  public needUpdateStructure: boolean;
}
